import { quarks } from 'ui-components'
import styled, { css } from 'styled-components'

type OverflowValue = 'visible' | 'hidden' | 'clip' | 'scroll' | 'auto'

const StyledPageWrapper = styled.div<{
  $fill?: boolean
  $overflowY?: OverflowValue
  $padTop?: keyof typeof quarks.margins
}>`
  max-width: ${(props) => (props.$fill ? '100vw' : DEFAULT_WIDTH)};
  ${(props) =>
    props.$fill
      ? css`
          height: 100%;
        `
      : ''}
  overflow-y: hidden;
  margin: 0 auto;
  ${(props) =>
    props.$padTop
      ? css`
          padding-top: ${quarks.margins[props.$padTop]};
        `
      : ''}
  > div {
    display: flex;
    flex-direction: column;
    flex-basis: 100%;
    max-height: 100%;
    height: 100%;
    width: 100%;
    overflow-y: ${(props) => props.$overflowY ?? 'auto'};
    // padding: 0 12px;
  }
`

type PageComponentProps = {
  /** Whether the children should take up the full width of the container. */
  fill?: boolean
  overflowY?: OverflowValue
  children: React.ReactNode
  padTop?: keyof typeof quarks.margins
}
const PageComponent = ({
  fill,
  overflowY,
  children,
  padTop = 'medium',
}: PageComponentProps) => {
  return (
    <StyledPageWrapper $fill={fill} $overflowY={overflowY} $padTop={padTop}>
      <div>{children}</div>
    </StyledPageWrapper>
  )
}

const DEFAULT_WIDTH = '1200px'

export default PageComponent
